import { QuestionAnswer } from './QuestionAnswer';

/**
 * Class representing a full answer for a survey.
 */
export class Answer {
    /**
     * Create an answer for a survey.
     * @param {Object} answer - The question answer
     * @param {Number} answer.answerId - The answer id.
     * @param {Date} answer.started - The date for when the survey answer was started.
     * @param {Date} answer.completed - The date for when the survey answer was completed.
     * @param {Array<QuestionAnswer>} answer.questionAnswers - Array of question answers.
     */
    constructor(answer) {
        this.answerId = answer.answerId;
        this.started = answer.started;
        this.completed = answer.completed;
        this.questionAnswers = answer.questionAnswers ? answer.questionAnswers.map(qa => new QuestionAnswer(qa)) : [];
    }
}
